import React from 'react';
import SiteFooter from '../components/common/SiteFooter';
import './Legal.css';

const Support: React.FC = () => {
  return (
    <div className="legal-page">
      <main className="legal-card" aria-labelledby="support-title">
        <header className="legal-card__header" data-tour="legal-header">
          <h1 id="support-title">Support</h1>
          <p>Need help with iKompete?</p>
        </header>

        <div className="legal-card__content" data-tour="legal-content">
          <section>
            <h2>Contact DSRS</h2>
            <p>
              For account access, competition issues, and general platform support, email:
            </p>
            <p>
              <a href="mailto:dsrs@business.illinois.edu">dsrs@business.illinois.edu</a>
            </p>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Support;

